import { styled } from '../Stitches';

export const LetterGrid = styled('div', {
  width: '100%',
  display: 'grid',

  alignItems: 'center',
  gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
  gap: '1em',
});
